/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function LowPoly(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0002 0.916984C10.3696 0.916984 10.7336 1.00107 11.0646 1.1621L11.2052 1.23632L11.2062 1.2373L17.0373 4.57616H17.0382C17.3444 4.75062 17.6064 4.99095 17.8087 5.27734C17.8518 5.32131 17.8928 5.36907 17.925 5.4248C17.953 5.47335 17.9733 5.52483 17.9894 5.57616C18.1591 5.91076 18.2495 6.28076 18.2502 6.65722V13.3398C18.2501 14.2008 17.787 14.9945 17.0402 15.4228H17.0392L11.2062 18.7627L11.2052 18.7637C10.8589 18.961 10.4691 19.0684 10.0714 19.0801C10.048 19.0823 10.0242 19.084 10.0002 19.084C9.97578 19.084 9.95166 19.0823 9.92789 19.0801C9.53053 19.0683 9.14112 18.9608 8.79507 18.7637L8.7941 18.7627L2.96109 15.4228C2.2136 14.9953 1.75024 14.2026 1.75015 13.3408V6.65917C1.75019 6.27584 1.84307 5.90631 2.01089 5.57616C2.02705 5.52483 2.04734 5.47335 2.07535 5.4248C2.10839 5.36761 2.15008 5.31824 2.19449 5.27343C2.39345 4.99346 2.65298 4.75386 2.96109 4.57714L8.7941 1.2373L8.79507 1.23632C9.16211 1.0272 9.57772 0.916984 10.0002 0.916984ZM3.25015 13.3408C3.25024 13.6605 3.42222 13.9587 3.70621 14.1211L9.25015 17.2949V10.4326L3.25015 6.96972V13.3408ZM10.7502 10.4326V17.2949L16.2941 14.1211L16.3947 14.0537C16.6183 13.8828 16.7501 13.6189 16.7502 13.3398V6.96972L10.7502 10.4326ZM10.0002 2.41698C9.83838 2.41698 9.67886 2.45811 9.53824 2.53808L9.53921 2.53905L4.03433 5.69042L10.0002 9.13378L15.965 5.69042L10.4611 2.53905V2.53808C10.3207 2.45838 10.1616 2.41698 10.0002 2.41698Z"
        fill="#35424F"
      />
    </svg>
  )
}

LowPoly.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default LowPoly
